/**
 * <NextSchoolAssessmentCard> — « Prochain contrôle », sur l'accueil de l'élève (organism).
 *
 * Le widget de l'accueil d'aujourd'hui (`NextAssessmentWidget`), dans la forme que le DS a déjà :
 * UNE carte, une ligne — `<SchoolAssessmentRow>`, la même que celle du bloc « Suivi » du parent.
 * Trois états, une seule boîte : le prochain contrôle ; sa forme pendant la première lecture ;
 * ou, quand aucun contrôle n'est à venir, la ligne « Ajouter un contrôle ».
 *
 * Tout mène au même endroit : la page « Mes contrôles ». La ligne vide aussi — elle n'ouvre pas le
 * formulaire d'ajout, c'est la page qui le porte.
 *
 * Composition seule : la surface est `<CardList>`, la ligne et son squelette viennent de leur
 * dossier.
 */
import React from "react"

import { DelayedSkeleton } from "../../atoms/Skeleton"
import { CardList, CardListLinkRow } from "../../molecules/CardList"
import { SchoolAssessmentRow } from "../../molecules/SchoolAssessmentRow"
import { SchoolAssessmentRowSkeleton } from "../../molecules/SchoolAssessmentRow/SchoolAssessmentRowSkeleton"
import { type UISchoolAssessment } from "../../../ports/primary/ui/types"

export type NextSchoolAssessmentCardProps = {
    /** Le prochain contrôle à venir — `null` quand il n'y en a aucun. */
    assessment: UISchoolAssessment | null
    /** La première lecture des contrôles est en route : la carte montre la forme de sa ligne. */
    loading?: boolean
    /** Ouvre « Mes contrôles » — depuis la ligne du contrôle comme depuis « Ajouter un contrôle ». */
    onOpenAssessments?: () => void
    /** Une colonne étroite (la pellicule du live du masteur) : la ligne dense. Défaut `false`. */
    dense?: boolean
    testID?: string
}

export function NextSchoolAssessmentCard(props: NextSchoolAssessmentCardProps) {
    const { assessment, loading = false, onOpenAssessments, dense = false, testID } = props

    return (
        <CardList testID={testID}>
            {assessment != null ? (
                <SchoolAssessmentRow assessment={assessment} onPress={onOpenAssessments} dense={dense} />
            ) : loading ? (
                <DelayedSkeleton accessibilityLabel="Chargement des contrôles">
                    <SchoolAssessmentRowSkeleton />
                </DelayedSkeleton>
            ) : (
                <CardListLinkRow label="Ajouter un contrôle" iconName="calendar-plus" onPress={onOpenAssessments} />
            )}
        </CardList>
    )
}
